import SignInForm from './SignInForm'
import logoImage from '@/assets/icons/logo.svg'

export const SignIn = () => {
    return (
        <div 
            className="w-full h-screen flex flex-col items-center justify-center py-16 px-4"
            style={{
                background: "linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #2563eb 100%)",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                overflow: "auto"
            }}
        >
            <div className="w-full max-w-md">
                {/* Logo */}
                <div className="mb-8 flex justify-center">
                    <div className="flex items-center space-x-2">
                        <img src={logoImage} alt="SplashMe Logo" className="h-10" />
                    </div>
                </div>

                {/* Main Card */}
                <div className="bg-white rounded-2xl p-8 shadow-xl">
                    {/* Header */}
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-900 mb-2">Welcome back!</h1>
                        <p className="text-gray-600">Please enter your credentials to sign in</p>
                    </div>
                    
                    <SignInForm disableSubmit={false} />
                </div>
            </div>
        </div>
    )
}

export default SignIn
